module.exports = __webpack_public_path__ + "static/img/more.ddaba0b5.png";